import clsx from "clsx";
import Label from "components/Label";
import Loading from "components/Loading";
import { useMemo } from "react";
import "./styles.scss";

type SwitchInputProps = {
	name: string;
	label: string;
	onChange: (newValue: boolean) => void;
	onBlur?: (evt: React.FocusEvent) => void;
	value: boolean;
	error?: string | boolean;
	touched?: boolean;
	textError?: string;
	triState?: boolean;
	hasMarginTop?: boolean;
	required?: boolean;
	disabled?: boolean;
	isLoading?: boolean;
	className?: string;
	hideOptional?: boolean;
};

export default function SwitchInput({
	name,
	label,
	value,
	required,
	disabled,
	isLoading,
	error,
	touched,
	onChange,
	onBlur,
	textError,
	hasMarginTop,
	hideOptional,
	className
}: Readonly<SwitchInputProps>) {
	const innerValue = useMemo<boolean>(() => Boolean(value ?? false), [value]);
	return (
		<div
			className={clsx({
				error: error && touched,
				hasMarginTop
			})}
		>
			<div className={clsx("switch-container")}>
				{isLoading && <Loading type="primary" />}
				<button
					name={name}
					className={clsx(
						"switch-button",
						innerValue ? "truthy" : "falsy",
						disabled
					)}
					type="button"
					onBlur={onBlur}
					disabled={disabled}
					onClick={() => onChange(!innerValue)}
				>
					<div className="switch-button-inner" />
				</button>
				<Label
					isRequired={!!required}
					className={clsx(className, "m-0")}
					hideOptional={hideOptional}
				>
					{label}
				</Label>
			</div>
			{error && touched && <div className="error-text">{textError}</div>}
		</div>
	);
}
